import React, { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';
import './Bonafide.css';
import ID from "../../assets/images/Id.jpeg";
import ID2 from "../../assets/images/ID2.jpeg";
import ID3 from "../../assets/images/ID3.jpg";



function IdDoc({ submitted, formData, selectedStudents, logoData }) {
  const [schoolData, setSchoolData] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);
  // const [walletPoints, setWalletPoints] = useState(0);
  const [logoURL, setLogoURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [udiseNumber, setUdiseNumber] = useState('');

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [design, setDesign] = useState('default');
  const [signatureURL, setSignatureURL] = useState(null);


  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);



  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);
  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      fetchSchoolData(schoolUdiseNumber);
      setUdiseNumber(schoolUdiseNumber);
    }
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    handleResize(); // Check initial screen size
    window.addEventListener("resize", handleResize); // Add event listener for window resize
    return () => window.removeEventListener("resize", handleResize); // Clean up event listener
  }, []);

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };


  const fetchSchoolData = async (udiseNumber) => {
    try {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onsuccess = async (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo); // Set the logo URL
            setSignatureURL(data.signature || "");

          }
          setLoading(false);
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
          setLoading(false);
        };
      };

      request.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error fetching school data:", error);
      setLoading(false);
    }
  };



  const renderIDCard = (student) => {
    if (!schoolData || !formData) return null;

    return (
      <div>
        {design === 'default' && (
          <div
            style={{
              backgroundImage: `url(${ID3})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              left: '0px',
              top: '0px',
              position: 'relative',
              width: '4.4in',
              height: '2.74in',
              margin: '0px',
              border: '1px solid black',
              boxSizing: 'border-box',
              padding: '0.0in',
              fontFamily: "'NotoSansDevanagari', sans-serif",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "0.20in",
                left: "0.08in",
              }}
            >
              {logoURL && (
                <img
                  src={logoURL}
                  alt="School Logo"
                  style={{ width: "38px", height: "38px" }}
                />
              )}
            </div>
            <div style={{ width: '82%', fontSize: '14px', fontWeight: 'bold', color: 'white', position: 'absolute', top: '0.16in', right: '0.1in', lineHeight: '1.15' }}>
              {schoolData?.schoolName}
              <div style={{ fontSize: '11px', fontWeight: 'normal', marginTop: '1px' }}> {language === "English" ? "Tal.- " : "ता.- "} {schoolData?.taluka}, {language === "English" ? "Dist.- " : "जि.- "} {schoolData?.jilha}</div>
              <div style={{ fontSize: '10.5px', fontWeight: 'normal' }}> {language === "English" ? "Udise No.- " : "UDISE क्र.- "} {schoolData?.udiseNumber}</div>
            </div>

            <div style={{ fontSize: '12.5px', color: 'black', marginTop: '120px', lineHeight: '1.18', marginLeft: '133px', overflow: 'hidden' }}>
              <p style={{ position: 'absolute', top: '0.72in', right: '0.35in', fontWeight: 'bold', margin: '0', fontSize: '12.5px', whiteSpace: 'nowrap' }}>{language === "English" ? "Roll No :" : "हजेरी क्र :"} {student.rollNo}</p>

              <p style={{ fontWeight: 'bold', margin: '2.5px 0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{language === "English" ? "Name :" : "नाव :"}<span style={{ marginLeft: '5px' }}> {student.stdName} {student.stdFather} {student.stdSurname}</span></p>
              <p style={{ fontWeight: 'bold', margin: '2.5px 0', whiteSpace: 'nowrap' }}>
                {language === "English" ? "Class :" : "वर्ग :"} <span style={{ marginLeft: '5px' }}>{student.currentClass}</span>
                <span style={{ marginLeft: '12px' }}>{language === "English" ? "Div :" : "तुकडी :"} <span style={{ marginLeft: '5px' }}>{student.division || ''}</span></span>
              </p>
              <p style={{ fontWeight: 'bold', margin: '2.5px 0', whiteSpace: 'nowrap' }}>{language === "English" ? "Mob No :" : "मोब क्र :"} <span style={{ marginLeft: '5px' }}>{student.mobileNo}</span></p>
              <p style={{ fontWeight: 'bold', margin: '2.5px 0', whiteSpace: 'nowrap' }}>{language === "English" ? "D.O.B :" : "जन्मतारीख :"} <span style={{ marginLeft: '5px' }}>{formatDate(student.dob)}</span></p>
              <p style={{ fontWeight: 'bold', lineHeight: '1.15', margin: '2.5px 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {language === "English" ? "Address :" : "पत्ता :"}
                <span style={{ marginLeft: '5px' }}>{student.address}</span>
              </p>
              <p style={{ fontWeight: 'bold', margin: '2.5px 0', whiteSpace: 'nowrap' }}>{language === "English" ? "Tal. :" : "ता. :"} <span style={{ marginLeft: '5px' }}> {student.taluka} , {language === "English" ? "Dist. :" : "जि. :"} {student.district}</span></p>
            </div>

            <div style={{ position: 'absolute', bottom: '0.14in', right: '0.1in' }}>
              {schoolData?.signature && (
                <img
                  src={schoolData.signature}
                  alt="Principal Signature"
                  style={{
                    width: '0.8in',
                    height: 'auto',
                  }}
                />
              )}
            </div>
            <div style={{ position: 'absolute', bottom: '0.02in', right: '0.28in', fontSize: '8px', color: 'black', fontWeight: 'bold' }}>
              {language === "English" ? "PRINCIPAL " : "प्राचार्य "}
            </div>
            <div style={{ position: 'absolute', bottom: '0.1in', right: '3.2in', fontSize: '14px', color: 'White' }}>
              <b>{student.educationalYear}</b>
            </div>
            <p style={{ position: 'absolute', bottom: '1.4in', right: '1.55in', fontSize: '16px', color: 'White' }}><b>{language === "English" ? "IDENTITY CARD" : "विद्यार्थी ओळखपत्र"}</b></p>

            <div style={{ position: 'absolute', top: '0.87in', right: '3.08in' }}>
              {student.stdPhoto && (
                <img
                  src={student.stdPhoto}
                  alt="Student Photo"
                  style={{
                    width: '1.1in',
                    height: '1.1in',
                    borderRadius: '50%',
                    transform: 'rotate(0deg)',
                  }}
                />
              )}
            </div>
          </div>
        )}

        {/* Second (New) Design */}
        {design === 'new' && (
          <div
            style={{
              backgroundImage: `url(${ID})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transform: 'rotate(0deg)',
              left: '0px',
              top: '0px',
              position: 'relative',
              width: '4.4in',
              height: '2.74in',
              margin: '0px',
              border: '1px solid black',
              boxSizing: 'border-box',
              padding: '0.0in',
              fontFamily: "'NotoSansDevanagari', sans-serif",
            }}
          >
            <div
              style={{
                transform: 'rotate(-90deg)',
                width: '2.3in',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'left',
                textAlign: 'center',
                position: 'absolute',
                left: '22px',
                top: 0,
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "0.16in",
                  left: "-0.18in",
                }}
              >
                {logoURL && (
                  <img
                    src={logoURL}
                    alt="School Logo"
                    style={{ width: "38px", height: "38px" }}
                  />
                )}
              </div>
              <div style={{ width: '89%', fontSize: '13px', fontWeight: 'bold', color: 'white', position: 'absolute', top: '0.02in', right: '0in', lineHeight: '1.15' }}>
                {schoolData?.schoolName}
                <div style={{ fontSize: '10.5px', fontWeight: 'normal', marginTop: '1px' }}> {language === "English" ? "Tal.- " : "ता.- "} {schoolData?.taluka}, {language === "English" ? "Dist.- " : "जि.- "} {schoolData?.jilha}</div>
                <div style={{ fontSize: '10.5px', fontWeight: 'normal' }}> {language === "English" ? "Udise No.- " : "UDISE क्र.- "} {schoolData?.udiseNumber}</div>
              </div>
            </div>

            <p style={{ transform: 'rotate(-90deg)', position: 'absolute', bottom: '1.38in', right: '3.1in', fontSize: '14px', color: 'white' }}>
              <b>{language === "English" ? "IDENTITY CARD" : "विद्यार्थी ओळखपत्र"}</b>
            </p>

            <div style={{ transform: 'rotate(-90deg)', fontSize: '11.5px', color: 'black', marginTop: '5px', marginLeft: '108px', width: '84%', lineHeight: '1.18', overflow: 'hidden' }}>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Name : " : "नाव : "} {student.stdName} {student.stdFather} {student.stdSurname}</b></p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}><b>{language === "English" ? "Roll No : " : "हजेरी क्र : "} {student.rollNo}</b></p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}><b>{language === "English" ? "Academic Year : " : "शैक्षणिक वर्ष : "} {student.educationalYear}</b></p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}><b>{language === "English" ? "D.O.B : " : "जन्मतारीख : "}{formatDate(student.dob)}</b></p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}>
                <b>{language === "English" ? "Class : " : "वर्ग : "} {student.currentClass}</b>
                <span style={{ marginLeft: '12px' }}><b>{language === "English" ? "Div : " : "तुकडी : "} {student.division || ''}</b></span>
              </p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}><b>{language === "English" ? "Contact No : " : "मोबाइल क्र : "} {student.mobileNo}</b></p>
              <p style={{ margin: '2px 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}><b>{language === "English" ? "Address : " : "पत्ता : "}{student.address || ''}</b></p>
            </div>

            <div style={{ transform: 'rotate(-90deg)' }}>
              <div style={{ position: 'absolute', bottom: '-1.85in', right: '1.15in' }}>
                {schoolData?.signature && (
                  <img
                    src={schoolData.signature}
                    alt="Principal Signature"
                    style={{
                      width: '0.9in',
                      height: 'auto',
                    }}
                  />
                )}
              </div>
              <p style={{ position: 'absolute', bottom: '-2.15in', right: '1.2in', fontSize: '11px', color: 'black', fontWeight: 'bold' }}> {language === "English" ? "PRINCIPAL " : "प्राचार्य "}</p>
            </div>

            <div style={{ position: 'absolute', top: '0.72in', right: '2.3in' }}>
              {student.stdPhoto && (
                <img
                  src={student.stdPhoto}
                  alt="Student Photo"
                  style={{
                    width: '1.15in',
                    height: '1.25in',
                    borderRadius: '50%',
                    border: '3px solid lightgray',
                    transform: 'rotate(-90deg)',
                  }}
                />
              )}
            </div>
          </div>
        )}

        {/* Third Alternative Design */}
        {design === 'alternative' && (
          <div
            style={{
              backgroundImage: `url(${ID2})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transform: 'rotate(0deg)',
              left: '0px',
              top: '0px',
              position: 'relative',
              width: '4.4in',
              height: '2.74in',
              margin: '0px',
              border: '1px solid black',
              boxSizing: 'border-box',
              padding: '0.0in',
              fontFamily: "'NotoSansDevanagari', sans-serif",
            }}
          >
            <div
              style={{
                transform: 'rotate(-90deg)',
                width: '2.3in',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'left',
                textAlign: 'center',
                position: 'absolute',
                left: '26px',
                top: 0,
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "0.2in",
                  left: "-0.18in",
                }}
              >
                {logoURL && (
                  <img
                    src={logoURL}
                    alt="School Logo"
                    style={{ width: "38px", height: "38px" }}
                  />
                )}
              </div>
              <div style={{ textAlign: 'center', marginBottom: '5px', fontSize: '13px', fontWeight: '600', color: 'white', position: 'absolute', top: '-0.05in', right: '0in', lineHeight: '1.15' }}>
                {schoolData?.schoolName}
                <div style={{ fontSize: '10.5px', fontWeight: 'normal', marginTop: '1px' }}> {language === "English" ? "Tal.- " : "ता.- "} {schoolData?.taluka}, {language === "English" ? "Dist.- " : "जि.- "} {schoolData?.jilha}</div>
                <div style={{ fontSize: '10.5px', fontWeight: 'normal' }}> {language === "English" ? "Udise No.- " : "UDISE क्र.- "} {schoolData?.udiseNumber}</div>
              </div>
            </div>

            {/* IDENTITY CARD label centered inside the light blue pill box */}
            <div
              style={{
                position: 'absolute',
                top: '1.31in',
                left: '1.65in',
                width: '1.8in',
                transform: 'rotate(-90deg)',
                textAlign: 'center',
                fontSize: '11.5px',
                color: '#002663',
                fontWeight: 'bold',
                zIndex: 5,
              }}
            >
              {language === "English" ? "IDENTITY CARD" : "विद्यार्थी ओळखपत्र"}
            </div>

            <div style={{ transform: 'rotate(-90deg)', fontSize: '11.5px', color: 'black', marginTop: '5px', marginLeft: '150px', width: '82%', lineHeight: '1.18', overflow: 'hidden' }}>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Name : " : "नाव : "} {student.stdName} {student.stdFather} {student.stdSurname}</b></p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}><b>{language === "English" ? "Roll No : " : "हजेरी क्र : "} {student.rollNo}</b></p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}><b>{language === "English" ? "Academic Year : " : "शैक्षणिक वर्ष : "} {student.educationalYear}</b></p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}><b>{language === "English" ? "D.O.B : " : "जन्मतारीख : "} {formatDate(student.dob)}</b></p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}>
                <b>{language === "English" ? "Class : " : "वर्ग : "}{student.currentClass}</b>
                <span style={{ marginLeft: '12px' }}><b>{language === "English" ? "Div : " : "तुकडी : "}{student.division || ''}</b></span>
              </p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}><b>{language === "English" ? "Contact No :" : "मोबाइल क्र :"} {student.mobileNo}</b></p>
              <p style={{ margin: '2px 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}><b>{language === "English" ? "Address : " : "पत्ता : "}{student.address || ''}</b></p>
            </div>

            {/* Principal Signature & Label */}
            {schoolData?.signature && (
              <img
                src={schoolData.signature}
                alt="Principal Signature"
                style={{
                  position: 'absolute',
                  top: '0.35in',
                  left: '3.50in',
                  width: '0.9in',
                  height: 'auto',
                  transform: 'rotate(-90deg)',
                  zIndex: 5,
                }}
              />
            )}
            <div
              style={{
                position: 'absolute',
                top: '0.5in',
                left: '3.7in',
                width: '1.2in',
                transform: 'rotate(-90deg)',
                textAlign: 'center',
                fontSize: '11px',
                color: 'black',
                fontWeight: 'bold',
                zIndex: 5,
              }}
            >
              {language === "English" ? "PRINCIPAL" : "प्राचार्य"}
            </div>

            <div style={{ position: 'absolute', top: '0.72in', right: '2.3in' }}>
              {student.stdPhoto && (
                <img
                  src={student.stdPhoto}
                  alt="Student Photo"
                  style={{
                    width: '1.15in',
                    height: '1.25in',
                    borderRadius: '50%',
                    border: '3px solid lightgray',
                    transform: 'rotate(-90deg)',
                  }}
                />
              )}
            </div>
          </div>
        )}

        {/* Fourth Design */}
        {design === 'fourth' && (
          <div
            style={{
              backgroundImage: `url(${ID2})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transform: 'rotate(0deg)',
              left: '0px',
              top: '0px',
              position: 'relative',
              width: '4.4in',
              height: '2.74in',
              margin: '0px',
              border: '1px solid black',
              boxSizing: 'border-box',
              padding: '0.0in',
              fontFamily: "'NotoSansDevanagari', sans-serif",
            }}
          >
            <div
              style={{
                transform: 'rotate(-90deg)',
                width: '2.3in',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'left',
                textAlign: 'center',
                position: 'absolute',
                left: '26px',
                top: 0,
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "0.2in",
                  left: "-0.18in",
                }}
              >
                {logoURL && (
                  <img
                    src={logoURL}
                    alt="School Logo"
                    style={{ width: "38px", height: "38px" }}
                  />
                )}
              </div>
              <div style={{ textAlign: 'center', marginBottom: '5px', fontSize: '13px', fontWeight: '600', color: 'white', position: 'absolute', top: '-0.05in', right: '0in', lineHeight: '1.15' }}>
                {schoolData?.schoolName}
                <div style={{ fontSize: '10.5px', fontWeight: 'normal', marginTop: '1px' }}> {language === "English" ? "Tal.- " : "ता.- "} {schoolData?.taluka}, {language === "English" ? "Dist.- " : "जि.- "} {schoolData?.jilha}</div>
                <div style={{ fontSize: '10.5px', fontWeight: 'normal' }}> {language === "English" ? "Udise No.- " : "UDISE क्र.- "} {schoolData?.udiseNumber}</div>
              </div>
            </div>

            {/* IDENTITY CARD label centered inside the light blue pill box */}
            <div
              style={{
                position: 'absolute',
                top: '1.22in',
                left: '1.72in',
                width: '1.8in',
                transform: 'rotate(-90deg)',
                textAlign: 'center',
                fontSize: '11.5px',
                color: '#002663',
                fontWeight: 'bold',
                zIndex: 5,
              }}
            >
              {language === "English" ? "IDENTITY CARD" : "विद्यार्थी ओळखपत्र"}
            </div>

            <div style={{ transform: 'rotate(-90deg)', fontSize: '11.5px', color: 'black', marginTop: '5px', marginLeft: '133px', width: '82%', lineHeight: '1.18', overflow: 'hidden' }}>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>{language === "English" ? "Name : " : "नाव : "} {student.stdName} {student.stdFather} {student.stdSurname}</b></p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}>
                <b>{language === "English" ? "Class : " : "वर्ग : "}{student.currentClass}</b>
                <span style={{ marginLeft: '12px' }}><b>{language === "English" ? "Div : " : "तुकडी : "}{student.division || ''}</b></span>
              </p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}>
                <b>{language === "English" ? "D.O.B : " : "जन्मतारीख : "} {formatDate(student.dob)}</b>
              </p>
              <p style={{ margin: '2px 0', whiteSpace: 'nowrap' }}>
                <b>{language === "English" ? "Contact No :" : "मोबाइल क्र :"} {student.mobileNo}</b>
              </p>
              <p style={{ margin: '2px 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                <b>{language === "English" ? "Address : " : "पत्ता : "}{student.address || ''}</b>
              </p>
            </div>

            {/* Principal Signature & Label */}
            {schoolData?.signature && (
              <img
                src={schoolData.signature}
                alt="Principal Signature"
                style={{
                  position: 'absolute',
                  top: '0.35in',
                  left: '3.50in',
                  width: '0.9in',
                  height: 'auto',
                  transform: 'rotate(-90deg)',
                  zIndex: 5,
                }}
              />
            )}
            <div
              style={{
                position: 'absolute',
                top: '0.5in',
                left: '3.7in',
                width: '1.2in',
                transform: 'rotate(-90deg)',
                textAlign: 'center',
                fontSize: '11px',
                color: 'black',
                fontWeight: 'bold',
                zIndex: 5,
              }}
            >
              {language === "English" ? "PRINCIPAL" : "प्राचार्य"}
            </div>

            <div style={{ position: 'absolute', top: '0.72in', right: '2.3in' }}>
              {student.stdPhoto && (
                <img
                  src={student.stdPhoto}
                  alt="Student Photo"
                  style={{
                    width: '1.15in',
                    height: '1.25in',
                    borderRadius: '50%',
                    border: '3px solid lightgray',
                    transform: 'rotate(-90deg)',
                  }}
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderPages = () => {
    if (!formData || !selectedStudents) return null;
    const pages = [];

    for (let i = 0; i < selectedStudents.length; i += 8) {
      const pageStudents = selectedStudents.slice(i, i + 8);
      pages.push(
        <div
          key={i}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 3.65in)',
            gridTemplateRows: 'repeat(4, 2.3in)',
            justifyContent: 'center',
            alignContent: 'center',
            gridGap: '0.05in 0.1in',
            width: '7.6in',
            minHeight: '10.0in',
            padding: '0.05in',
            fontFamily: "'NotoSansDevanagari', sans-serif",
            border: '1px solid #aaa',
            boxSizing: 'border-box',
            margin: '0 auto 30px auto',
            backgroundColor: '#ffffff',
            pageBreakAfter: 'always',
            pageBreakInside: 'avoid',
            breakAfter: 'page',
            breakInside: 'avoid',
          }}
          className="print-page"
        >
          {pageStudents.map((student, idx) => (
            <div
              key={student._id || student.id || idx}
              style={{
                width: '3.65in',
                height: '2.3in',
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              <div
                style={{
                  transform: 'scale(0.79)',
                  transformOrigin: '0 0',
                  width: '4.6in',
                  height: '2.9in',
                }}
              >
                {renderIDCard(student)}
              </div>
            </div>
          ))}
        </div>
      );
    }
    return pages;
  };

  const printCertificate = () => {
    const printContent = document.getElementById("print-content");
    if (!printContent) return;

    // Get or create hidden print iframe
    let iframe = document.getElementById("print-iframe");
    if (iframe) {
      iframe.remove();
    }

    iframe = document.createElement("iframe");
    iframe.id = "print-iframe";
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "0px";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Print ID Cards</title>
          <style>
            @page {
              size: A4 portrait;
              margin: 0;
            }
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              color-adjust: exact !important;
              box-sizing: border-box;
            }
            body {
              margin: 0;
              padding: 0;
              background: #ffffff;
              font-family: 'NotoSansDevanagari', sans-serif;
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            .print-page {
              width: 7.8in;
              height: 10.6in;
              display: grid;
              grid-template-columns: repeat(2, 3.65in);
              grid-template-rows: repeat(4, 2.3in);
              justify-content: center;
              align-content: center;
              grid-gap: 0.1in 0.15in;
              padding: 0.2in 0.1in;
              box-sizing: border-box;
              border: none;
              overflow: hidden;
              page-break-after: always;
              break-after: page;
              page-break-inside: avoid;
              break-inside: avoid;
              margin: 0 auto;
            }
            .print-page:last-child {
              page-break-after: auto;
              break-after: auto;
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    iframeDoc.close();

    // Wait for all images inside the iframe to finish loading before launching print preview
    const checkAndPrint = async () => {
      const images = Array.from(iframeDoc.images);
      const imagePromises = images.map((img) => {
        if (img.complete && img.naturalHeight !== 0) {
          return Promise.resolve();
        }
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      });

      await Promise.race([
        Promise.all(imagePromises),
        new Promise((resolve) => setTimeout(resolve, 1500))
      ]);

      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      }, 150);
    };

    checkAndPrint();
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1em",
        }}
      >
        <div id="print-content" className='main-content-of-page'>
          {loading ? <p>Loading...</p> : renderPages()}
        </div>


        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button style={{ width: '80px', height: '40px', marginLeft: '10px', padding: '0 8px', backgroundColor: 'gray', borderRadius: '5px' }} onClick={() => setDesign(design === 'default' ? 'new' : design === 'new' ? 'alternative' : design === 'alternative' ? 'fourth' : 'default')}>
            Next <i className="fa-solid fa-circle-chevron-right"></i>
          </button></div>
        <br />
        <div >
          <button
            onClick={printCertificate}
            style={{ width: '80px', height: '40px', marginLeft: '10px', padding: '0 10px', borderRadius: '5px' }}
          >
            Print
          </button>
        </div>

      </div>
    </>
  );
}

export default IdDoc;
